module.exports = __webpack_public_path__ + "img/pro-photo9-1.3fc5dcc3.png";